export const getStickyButtonOnHoverClassNames = (
	backgroundColor: string | undefined,
) => {
	switch (backgroundColor) {
		case 'bg-primary-lightViolet':
			return 'hover:bg-secondary-lemon hover:text-primary-violet';
		case 'bg-primary-violet':
			return 'hover:bg-secondary-lemon hover:text-primary-violet';
		case 'bg-primary-green':
			return 'hover:bg-secondary-lemon hover:text-primary-green';
		case 'bg-primary-blue':
			return 'hover:bg-secondary-lemon hover:text-primary-blue';
		case 'bg-primary-pink':
			return 'hover:bg-secondary-lemon hover:text-primary-pink';
		default:
			return 'hover:bg-primary-lightViolet hover:text-white';
	}
};
